import { observer } from "mobx-react";
import React from "react";
import { Title, Modal, Stack, Text, Anchor } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import {
  JsonView,
  allExpanded,
  collapseAllNested,
  darkStyles,
} from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { MODALS } from "../../helpers/constants";
import _ from "lodash";
import KeyDisplay from "./keyDisplay";
import NodeAlias from "../interactiveData/nodeAlias";
import GuaranteedUptime from "./guaranteedUptime";
import { TextWithInfo } from "../modals/textWithInfo";
import { TextWithInfoAndIcon } from "./textWithInfoAndIcon";
import { ARTICLES } from "../../docs/docsIndex";
import { IconClock } from "@tabler/icons-react";

const ManageUptime = observer(({ cubby }: { cubby: Cubby }) => {
  return (
    <>
      <Modal
        opened={cubby.currentModal === MODALS.MANAGE_UPTIME}
        onClose={() => cubby.setModal(null)}
        title={
          <TextWithInfoAndIcon
            text="Node Uptime"
            articleSlug={ARTICLES.GET_GUARANTEED_UPTIME.slug}
            icon={<IconClock size={24} />}
            cubby={cubby}
            textSize="lg"
          />
        }
      >
        <Stack>
          <GuaranteedUptime cubby={cubby} />
        </Stack>
      </Modal>
    </>
  );
});

export default ManageUptime;
